import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { formItemProps } from '@next-adapter/generators/form/form-shared/form-item-props.js'
import { formLabel } from '@next-adapter/generators/form/form-shared/form-label.js'
import { labelWithDescription } from '@next-adapter/generators/form/form-shared/label-with-description.js'
import { renderNumberFieldFormFieldTemplate } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-number-field.js'
import { defaultValueFromSourceHandler } from './default-value-from-source-handler.js'

export function renderNumberField(
  field: SchemaField,
  indent: string,
  label: string,
  fieldType: string,
  hintJSX: string,
  context: FieldRenderContext
): string {
  const defaultValueFromHandler = defaultValueFromSourceHandler(field, context)
  const stepProp = field.type === 'decimal' ? `\n${indent}          step="any"` : ''
  const emptyValue = field.required ? 'undefined' : 'null'
  const applyDefaultValueFrom = defaultValueFromHandler
    ? `${indent}            ${defaultValueFromHandler}(normalizedValue)\n`
    : ''

  return renderNumberFieldFormFieldTemplate({
    indent: indent,
    fieldName: field.name,
    formItemProps: formItemProps(field),
    labelWithDescription: labelWithDescription(formLabel(field, label), hintJSX, `${indent}      `),
    fieldType: fieldType,
    stepProp: stepProp,
    toLowerCase: label.toLowerCase(),
    emptyValue: emptyValue,
    applyDefaultValueFrom: applyDefaultValueFrom
  })
}
